<div class="fc-view fc-month-view fc-basic-view" (click)="hideMenu($event)" *ngIf="monthView">
  <table>
    <thead class="fc-head">
    <tr>
      <td class="fc-widget-header">
        <div class="fc-row fc-widget-header">
          <table>
            <thead>
            <tr>
              <th *ngFor="let day of monthView.days | slice: 0: 7"
                  class="fc-day-header fc-widget-header">
                {{ 'PAYROLL_PREPARE.weekday' | translate:{day: day | gpDayOfWeek} }}
              </th>
            </tr>
            </thead>
          </table>
        </div>
      </td>
    </tr>
    </thead>
    <tbody class="fc-body">
    <tr>
      <td class="fc-widget-content">
        <div class="fc-day-grid-container">
          <div class="fc-day-grid">
            <div *ngFor="let rowIndex of monthView.rowOffsets"
                 class="fc-row fc-week fc-widget-content"
                 [style.zIndex]="menuRowIndex === rowIndex ? 1 : 0">
              <div class="fc-content-skeleton">
                <table>
                  <thead>
                  <tr>
                    <td *ngFor="let day of monthView.days | slice: rowIndex: rowIndex + 7"
                        class="fc-day-number"
                        [class.fc-other-month]="!day.inMonth"
                        [class.fc-past]="day.isPast"
                        [class.fc-today]="day.isToday"
                        [class.fc-future]="day.isFuture"
                        [attr.data-date]="day.date | date:'yyyy-MM-dd'">
                      <div *ngIf="day.type !== 'OUT' && !isReadOnly"
                           class="icon-btn pointer add-dropdown-btn"
                           (click)="onAddEventClick(day.date)">
                        <i [attr.test-date]="day.date | date:'yyyy-MM-dd'"
                           [attr.test-id]="'time-calendar-month-plus-button'"
                           class="fa fa-light fa-plus"></i>
                      </div>
                      {{ day.date | date:'d' }}
                    </td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td *ngFor="let day of monthView.days | slice: rowIndex: rowIndex + 7"
                        class="fc-event-container"
                        style="height: auto;">
                      <gp-calendar-presence
                        *ngFor="let event of day.presences"
                        [event]="event"
                        [attr.test-id]="day.date | date:'yyyy-MM-dd'"
                        [date]="day.date | date:'yyyy-MM-dd'"
                        [weekview]="false"
                        [isReadOnly]="isReadOnly || isEss"
                        (eventChanged)="onEventChanged(event)"
                        (click)="onEditEventClick(event, $event)"
                      ></gp-calendar-presence>
                    </td>
                  </tr>
                  <tr>
                    <td *ngFor="let day of monthView.days | slice: rowIndex: rowIndex + 7"
                        class="fc-event-container inside {{day.cssClass}}"
                        [style.backgroundColor]="day.backgroundColor"
                        [style.color]="day.textColor">
                      <span class="day-label">{{day.label | translate}}</span>
                      <ng-container *ngFor="let event of day.absences; let absenceIndex = index">
                        <ng-container *ngIf="!event.attributes.status">
                          <gp-calendar-absence
                            [class.day-type-priority-on-absence]="day.hasPriorityOnAbsence[absenceIndex]"
                            [event]="event"
                            [date]="day.date | date:'yyyy-MM-dd'"
                            [weekview]="false"
                            [isReadOnly]="isReadOnly"
                            (eventChanged)="onEventChanged(event)"
                            (resizeEvent)="onEventResize($event)"
                            (click)="onEditEventClick(event, $event)">
                          </gp-calendar-absence>
                        </ng-container>
                        <ng-container *ngIf="event.attributes.status">
                          <gp-calendar-pending-absence
                            [event]="event"
                            [date]="day.date | date:'yyyy-MM-dd'"
                            [weekview]="false">
                          </gp-calendar-pending-absence>
                        </ng-container>
                      </ng-container>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</div>
